import { render, staticRenderFns } from "./ArticleTilesContainer.vue?vue&type=template&id=45a5d603&scoped=true"
import script from "./ArticleTilesContainer.vue?vue&type=script&lang=js"
export * from "./ArticleTilesContainer.vue?vue&type=script&lang=js"
import style0 from "./ArticleTilesContainer.vue?vue&type=style&index=0&id=45a5d603&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a5d603",
  null
  
)

export default component.exports